export function getInvertedTransform(prev: DOMRect, end: DOMRect) {
  const left = prev.left - end.left;
  const top = prev.top - end.top;
  const scaleX = prev.width / end.width;
  const scaleY = prev.height / end.height;
  const transform = `translate(${left}px, ${top}px) scale(${scaleX}, ${scaleY})`;
  return transform;
}
